import { fileSizeInMegaBytes } from 'shared/helpers/FileHelper';

// AI F §1.1.1, §1.1.5 — size in MB.
export const formatSize = bytes => {
  const megaBytes = fileSizeInMegaBytes(bytes || 0);
  if (megaBytes === 0) return '0 MB';

  return megaBytes < 0.01 ? '< 0.01 MB' : `${megaBytes.toFixed(2)} MB`;
};

export default { formatSize };
